export default __webpack_public_path__ + "static/media/payment_processing_mobile.9c1448f7.mp4";